import notificationPreferencesResource from "@/shared/resource/notificationPreferences";
import { authorizedAxios,  } from "./authorizedAxios";
import {
    NotificationPreferencesResponse, NotificationPreferenceUpdateRequest,
} from "@/shared/types";

export function getNotificationPreferences () {
    return authorizedAxios.get<NotificationPreferencesResponse>(notificationPreferencesResource.getNotificationPreferences());
}

export function updateNotificationPreferences (request: NotificationPreferenceUpdateRequest): Promise<NotificationPreferencesResponse> {
    return authorizedAxios.put<NotificationPreferencesResponse>(notificationPreferencesResource.updateNotificationPreferences(), request)
        .then(response => response.data);
}